import { render, staticRenderFns } from "./NyDigCustodialInput.vue?vue&type=template&id=15ec72a4&"
import script from "./NyDigCustodialInput.vue?vue&type=script&lang=ts&"
export * from "./NyDigCustodialInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports